import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import App from "./App.tsx";
import "./index.css";

// Load fonts asynchronously to avoid render-blocking
import("@fontsource/inter/400.css");
import("@fontsource/inter/500.css");
import("@fontsource/inter/600.css");
import("@fontsource/inter/700.css");
import("@fontsource/space-grotesk/400.css");
import("@fontsource/space-grotesk/500.css");
import("@fontsource/space-grotesk/600.css");
import("@fontsource/space-grotesk/700.css");

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
